import { IAlleleEplet } from "./allele-eplet";

export interface IHlaAllele {
    id: number;
    gene: string;
    alleleGroup: string;
    hlaProtein: string
    proteinSequence: string;
    serologicalEquivalent: number;
    alleleEplets: IAlleleEplet[];
    hlaString: string;
}